<app-header-style-one></app-header-style-one>

<div class="page-title-area">
    <div class="container">
        <h1>Photo Gallery – Lama Driving School</h1>
    </div>
</div>

<!-- <div class="gallery-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="circle-image">
                    <img *ngIf="!userDetail?.userImage" src="./assets/MayAvatar.jpeg" style="    max-width: 16%;   ">

                    <img *ngIf="userDetail?.userImage" [src]="createImgPath(userDetail?.userImage)">

                </div>
                <button style="margin: 20px;" (click)="userUserPakage()"
                    class="btn btn-icon btn-primary btn-hover-primary btn-sm">
                    <i class="fa fa-credit-card" aria-hidden="true"></i>
                    {{"MENU.UserUsedPakage" | translate}}
                </button>

            </div>
            <div class="col-lg-9 col-md-9 col-sm-12" style="    MARGIN-TOP: 80PX; ">
                <h4 style="color: white;">{{userDetail?.userName}}</h4>
                <i style="color: white;" class="fas fa-user-edit	" aria-hidden="true">{{userDetail?.avatarTotal}} </i>
                &nbsp; &nbsp;
                <i style="color: white;" class="fa fa-list-ul" aria-hidden="true"> {{userDetail?.promptTotal}}</i>
                &nbsp; &nbsp;
                <i style="color: white;" class="fas fa-image" aria-hidden="true"> {{userDetail?.printTotal}}</i>
               
                <button style="margin: 20px;" (click)="aiAvatar()"
                    class="btn btn-icon btn-primary btn-hover-primary btn-sm">
                    <i class="fas fa-user-edit	" aria-hidden="true"></i>
                    &nbsp;    {{ "MENU.AIAvatar" | translate }}
                </button>
                <button style="margin: 20px;" (click)="aiPrompt()"
                    class="btn btn-icon btn-primary btn-hover-primary btn-sm">
                    <i class="fa fa-list-ul" aria-hidden="true"></i>
                    &nbsp;    {{ "MENU.AIPrompt" | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="container pt-100 pb-70">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let image of _album; let i = index">
                <div class="single-gallery-item mb-30">
                    <div class="image-wrapper" (mouseenter)="showSections = true" (mouseleave)="showSections = false">
                        <img [src]="image.thumb" (click)="open(i)" />
                        <div class="hover-sections" *ngIf="showSections">
                            <div class="icon-row">
                                <button class="icon-button" (click)="open(i)" title="view">
                                    <i class="fa fa-eye"></i>
                                </button>
                                <button class="icon-button" (click)="print(image?.printimage)" title="Print">
                                    <i class="fa fa-print"></i>
                                </button>
                                <button class="icon-button" (click)="downloadImage(i)" title="Download">
                                    <i class="fa fa-download"></i>
                                </button>
                                <button class="icon-button" (click)="archivedImage(image.referenceId)" title="archived">
                                    <i class='bx bx-archive-in' style="font-size: 25px;"></i> </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12" style="    text-align: center; ">
            <button (click)="previousPage()" class="pagination-button" [disabled]="currentPage === 1">Previous</button>
            <ng-container *ngFor="let page of getVisiblePageNumbers()">
                <button (click)="onPageChange(page)" class="pagination-button"
                    [class.current-page]="currentPage === page">{{
                    page }}</button>
            </ng-container>
            <button (click)="nextPage()" class="pagination-button" [disabled]="currentPage === totalPages">Next</button>
        </div>
    </div>
</div> -->
